import React from "react";
import styles from "./EmptyList.module.scss";
import Image_Prefix from "../../assets";

const EmptyList = ({ text }) => {
  return (
    <div className={styles.empty_list_container}>
      <img src={Image_Prefix.empty_list} alt="empty_list" />
      <p className={styles.text}>{text}</p>
    </div>
  );
};

export default EmptyList;
